import { render } from "./NAvatar.vue?vue&type=template&id=5c0be1ba"
import script from "./NAvatar.vue?vue&type=script&lang=js"
export * from "./NAvatar.vue?vue&type=script&lang=js"

import "./NAvatar.vue?vue&type=style&index=0&id=5c0be1ba&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__